import { configureStore } from '@reduxjs/toolkit';
// import { authReducer } from 'slices/auth-slice';
// import { layoutReducer } from 'slices/layout-slice';
// import { baseApi } from 'slices/base-api';
import { eventManagementReducer } from './slices/events.slice';
import darkModeSlice from './slices/theme-slice';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from './slices/base-api';
import { authReducer } from './slices/auth-slice';
// @ts-ignore
import { layoutReducer } from './slices/layout-slice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    eventManagement: eventManagementReducer,
    layout: layoutReducer,
    theme: darkModeSlice,
    [baseApi.reducerPath]: baseApi.reducer,
  },

  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export default store;






